/**
 * useErrorBuffer — subscribe to the global error/warn rolling buffer.
 */
import { useEffect, useState } from 'react';
import {
  getErrorBufferSnapshot,
  subscribeErrorBuffer,
  type ErrorBufferEntry,
} from '../services/errorBufferStore';

export function useErrorBuffer(): ReadonlyArray<ErrorBufferEntry> {
  const [entries, setEntries] = useState<ReadonlyArray<ErrorBufferEntry>>(() => getErrorBufferSnapshot());
  useEffect(() => {
    const unsub = subscribeErrorBuffer((next) => setEntries(next));
    return unsub;
  }, []);
  return entries;
}
